module.exports = {"pageTitleText":"线路分组","recordLineGroupName":"分组名称","createText":"添加线路分组"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/recordLineGroups.json
// module id = VsTk
// module chunks = 3